import { apiRequest } from '@/utils/api-request';
import { useOrgStore } from '@/stores/org-store';

export interface EditApiKeyProps {
  id: string;
  name: string;
  description: string;
}

export const editCapitolKey = async ({
  id,
  name,
  description,
}: EditApiKeyProps) => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;

  const response = await apiRequest({
    url: `/internal-api-keys/${orgId}/${id}`,
    target: 'platform',
    method: 'PATCH',
    body: {
      name,
      description,
    },
  });

  if (response?.detail) {
    throw new Error(response.detail || 'Failed to edit capitol key');
  }

  return response;
};
